/**
 * Extend core messages JS of Magento_Ui
 **/
define([
    'jquery'
], function ($) {
    "use strict";

    return function (Component) {
        return Component.extend({
            /**
             * Increase the hide message timer to 7s from 5s
             *
             * @param {Boolean} isHidden
             * @override
             */
            onHiddenChange: function (isHidden) {
                var self = this;

                // Hide message block if needed
                if (isHidden) {
                    // clear timeout function before set it again
                    // to make sure the previous timeout callback
                    // is cleared
                    clearTimeout(window.messageTimeout);

                    window.messageTimeout = setTimeout(() => {
                        $(self.selector).hide('blind', {}, 500);
                    }, 7000);
                }
            }
        });
    };
});
